(function () {
  if (window.__veloraCartColors) return;
  window.__veloraCartColors = true;

  var cache = {};
  var styleDone = false;

  function injectStyle() {
    if (styleDone) return; styleDone = true;
    var css = [
      '.velora-cc{display:flex;flex-direction:column;gap:10px;margin:12px 0 4px;max-width:280px}',
      '.velora-cc__row{display:flex;flex-direction:column;gap:4px}',
      '.velora-cc__label{font-size:1.2rem;letter-spacing:.02em;opacity:.75}',
      '.velora-cc__select{font:inherit;font-size:1.4rem;padding:8px 10px;border:1px solid rgba(0,0,0,.18);border-radius:8px;background:#fff;color:inherit;width:100%}',
      '.velora-cc.is-loading{opacity:.45;pointer-events:none}',
      '.velora-cc__err{font-size:1.15rem;color:#b3261e;display:none}',
      '.velora-cc.has-err .velora-cc__err{display:block}'
    ].join('');
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function optName(product, i) {
    var o = product.options && product.options[i];
    if (o == null) return 'Option ' + (i + 1);
    return typeof o === 'string' ? o : (o.name || ('Option ' + (i + 1)));
  }

  function optCount(product) {
    if (product.options && product.options.length) return product.options.length;
    return (product.variants[0] && product.variants[0].options) ? product.variants[0].options.length : 0;
  }

  function valuesFor(product, i) {
    var seen = {}, out = [];
    product.variants.forEach(function (v) {
      var val = v.options[i];
      if (val == null || seen[val]) return;
      seen[val] = 1; out.push(val);
    });
    return out;
  }

  function currentOptions(product, variantId) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(variantId)) return product.variants[i].options.slice();
    }
    return product.variants[0] ? product.variants[0].options.slice() : [];
  }

  function fetchProduct(handle) {
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return cache[handle];
  }

  function parseLine(itemEl) {
    var link = itemEl.querySelector('.cart-item__name');
    var qtyInput = itemEl.querySelector('input[data-quantity-variant-id]');
    if (!link || !qtyInput) return null;
    var href = link.getAttribute('href') || '';
    var after = href.split('/products/')[1];
    if (!after) return null;
    var handle = after.split('?')[0].split('#')[0];
    return {
      handle: handle,
      variantId: qtyInput.getAttribute('data-quantity-variant-id'),
      index: qtyInput.getAttribute('data-index'),
      qty: parseInt(qtyInput.value, 10) || 1
    };
  }

  function build(itemEl, line, product) {
    if (!product || !product.variants || product.variants.length < 2) return;
    var details = itemEl.querySelector('.cart-item__details');
    if (!details || details.querySelector('.velora-cc')) return;

    var cur = currentOptions(product, line.variantId);
    var wrap = document.createElement('div');
    wrap.className = 'velora-cc';
    wrap.setAttribute('data-velora-cc', '');
    wrap.dataset.index = line.index;
    wrap.dataset.variantId = line.variantId;
    wrap.dataset.qty = line.qty;
    wrap._variants = product.variants;

    var n = optCount(product);
    for (var i = 0; i < n; i++) {
      (function (idx) {
        var row = document.createElement('div'); row.className = 'velora-cc__row';
        var lab = document.createElement('span'); lab.className = 'velora-cc__label'; lab.textContent = optName(product, idx);
        var sel = document.createElement('select'); sel.className = 'velora-cc__select';
        sel.setAttribute('data-velora-cc-opt', ''); sel.dataset.optIndex = idx;
        valuesFor(product, idx).forEach(function (val) {
          var o = document.createElement('option'); o.value = val; o.textContent = val;
          if (val === cur[idx]) o.selected = true;
          sel.appendChild(o);
        });
        sel.addEventListener('change', function (e) { e.stopPropagation(); });
        sel.addEventListener('click', function (e) { e.stopPropagation(); });
        row.appendChild(lab); row.appendChild(sel); wrap.appendChild(row);
      })(i);
    }
    var err = document.createElement('div'); err.className = 'velora-cc__err';
    err.textContent = 'That combination is unavailable — pick another.';
    wrap.appendChild(err);
    details.appendChild(wrap);
  }

  function findVariant(wrap) {
    var chosen = [];
    wrap.querySelectorAll('[data-velora-cc-opt]').forEach(function (s) {
      chosen[parseInt(s.dataset.optIndex, 10)] = s.value;
    });
    var vs = wrap._variants || [];
    for (var i = 0; i < vs.length; i++) {
      var ok = true;
      for (var k = 0; k < chosen.length; k++) { if (vs[i].options[k] !== chosen[k]) { ok = false; break; } }
      if (ok && vs[i].available !== false) return vs[i];
    }
    return null;
  }

  var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function swap(wrap) {
    var variant = findVariant(wrap);
    if (!variant) { wrap.classList.add('has-err'); return; }
    wrap.classList.remove('has-err');
    var oldId = String(wrap.dataset.variantId);
    var newId = String(variant.id);
    if (newId === oldId) return;
    var qty = parseInt(wrap.dataset.qty, 10) || 1;
    var inDrawer = !!wrap.closest('#CartDrawer');
    wrap.classList.add('is-loading');

    var updates = {};
    updates[oldId] = 0;
    updates[newId] = qty;

    fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: updates }) })
      .then(function (r) {
        if (!r.ok) throw new Error('update failed');
        return r.json();
      })
      .then(function (cart) {
        var ok = false;
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].id) === newId && cart.items[i].quantity > 0) { ok = true; break; }
          }
        }
        if (!ok) throw new Error('variant not in cart after update');
        try { if (inDrawer) sessionStorage.setItem('velora_open_drawer', '1'); } catch (e) {}
        window.location.reload();
      })
      .catch(function () { wrap.classList.remove('is-loading'); wrap.classList.add('has-err'); });
  }

  function scan() {
    injectStyle();
    document.querySelectorAll('.cart-item').forEach(function (itemEl) {
      if (itemEl.getAttribute('data-vcc')) return;
      var line = parseLine(itemEl);
      if (!line) return;
      itemEl.setAttribute('data-vcc', '1');
      fetchProduct(line.handle).then(function (p) { build(itemEl, line, p); });
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var sel = t.closest('[data-velora-cc-opt]');
    if (!sel) return;
    e.stopPropagation();
    var wrap = sel.closest('[data-velora-cc]');
    if (wrap) swap(wrap);
  }, true);

  var scheduled = false;
  function rescan() { if (scheduled) return; scheduled = true; setTimeout(function () { scheduled = false; scan(); }, 60); }

  function observe() {
    var targets = ['#CartDrawer', '#main-cart-items', '#cart-notification-product', 'cart-drawer', 'cart-items'];
    targets.forEach(function (t) {
      var el = document.querySelector(t);
      if (el) new MutationObserver(rescan).observe(el, { childList: true, subtree: true });
    });
  }

  function boot() {
    scan();
    observe();
    try {
      if (sessionStorage.getItem('velora_open_drawer')) {
        sessionStorage.removeItem('velora_open_drawer');
        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.open === 'function') setTimeout(function () { cd.open(); }, 350);
      }
    } catch (e) {}
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();